import React from "react";
import { BoundaryLegendCategory } from "../models";

interface Props {
  readonly category: BoundaryLegendCategory;
}

const BoundaryLegendIcon = ({ category }: Props) => {
  const icon =
    category === BoundaryLegendCategory.Place ? (
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3 3V15H15V3H3ZM1 0C0.447715 0 0 0.447716 0 1V17C0 17.5523 0.447716 18 1 18H17C17.5523 18 18 17.5523 18 17V1C18 0.447715 17.5523 0 17 0H1Z"
        fill="#333333"
      />
    ) : category === BoundaryLegendCategory.RiskCalcArea ? (
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.88235 0C3.08133 0 0 3.08134 0 6.88236V11.1176C0 14.9187 3.08134 18 6.88236 18H11.1176C14.9187 18 18 14.9187 18 11.1176V6.88235C18 3.08133 14.9187 0 11.1176 0H6.88235ZM3.17647 6.88236C3.17647 4.83565 4.83565 3.17647 6.88235 3.17647H11.1176C13.1643 3.17647 14.8235 4.83565 14.8235 6.88235V11.1176C14.8235 13.1643 13.1643 14.8235 11.1176 14.8235H6.88236C4.83565 14.8235 3.17647 13.1643 3.17647 11.1176V6.88236ZM6.46904 2.40376C6.61431 2.38962 6.7618 2.38236 6.91123 2.38236H7.573C8.01158 2.38236 8.36712 2.02682 8.36712 1.58825C8.36712 1.14967 8.01158 0.794128 7.573 0.794128H6.91123C6.71035 0.794128 6.51151 0.803885 6.3152 0.82299C5.87868 0.865472 5.55925 1.25378 5.60174 1.69029C5.64422 2.12681 6.03252 2.44624 6.46904 2.40376ZM10.4848 0.794128C10.0462 0.794128 9.69064 1.14967 9.69064 1.58825C9.69064 2.02682 10.0462 2.38236 10.4848 2.38236H11.1465C11.296 2.38236 11.4435 2.38962 11.5887 2.40376C12.0252 2.44624 12.4135 2.12681 12.456 1.69029C12.4985 1.25378 12.1791 0.865472 11.7426 0.82299C11.5462 0.803885 11.3474 0.794128 11.1465 0.794128H10.4848ZM4.05676 3.40338C4.39563 3.12495 4.44463 2.62454 4.16621 2.28567C3.88779 1.9468 3.38737 1.8978 3.0485 2.17622C2.74062 2.42918 2.45805 2.71175 2.20509 3.01963C1.92667 3.3585 1.97567 3.85891 2.31454 4.13734C2.65341 4.41576 3.15382 4.36676 3.43225 4.02789C3.61954 3.79993 3.8288 3.59067 4.05676 3.40338ZM15.0093 2.17622C14.6704 1.8978 14.17 1.9468 13.8916 2.28567C13.6131 2.62454 13.6621 3.12496 14.001 3.40338C14.229 3.59067 14.4382 3.79993 14.6255 4.02789C14.9039 4.36676 15.4044 4.41576 15.7432 4.13734C16.0821 3.85892 16.1311 3.3585 15.8527 3.01963C15.5997 2.71175 15.3171 2.42918 15.0093 2.17622ZM2.43263 6.44017C2.47511 6.00365 2.15568 5.61535 1.71916 5.57287C1.28265 5.53038 0.894342 5.84981 0.85186 6.28633C0.832754 6.48264 0.822998 6.68148 0.822998 6.88236V7.54413C0.822998 7.98271 1.17854 8.33825 1.61712 8.33825C2.05569 8.33825 2.41123 7.98271 2.41123 7.54413V6.88236C2.41123 6.73293 2.41849 6.58543 2.43263 6.44017ZM17.2059 6.28633C17.1634 5.84981 16.7751 5.53038 16.3386 5.57287C15.9021 5.61535 15.5827 6.00365 15.6251 6.44017C15.6393 6.58544 15.6465 6.73293 15.6465 6.88236V7.54413C15.6465 7.98271 16.0021 8.33825 16.4406 8.33825C16.8792 8.33825 17.2348 7.98271 17.2348 7.54413V6.88236C17.2348 6.68148 17.225 6.48264 17.2059 6.28633ZM2.41123 10.4559C2.41123 10.0173 2.05569 9.66177 1.61712 9.66177C1.17854 9.66177 0.822998 10.0173 0.822998 10.4559V11.1177C0.822998 11.3185 0.832754 11.5174 0.85186 11.7137C0.894342 12.1502 1.28265 12.4696 1.71916 12.4272C2.15568 12.3847 2.47511 11.9964 2.43263 11.5599C2.41849 11.4146 2.41123 11.2671 2.41123 11.1177V10.4559ZM17.2348 10.4559C17.2348 10.0173 16.8792 9.66177 16.4406 9.66177C16.0021 9.66177 15.6465 10.0173 15.6465 10.4559V11.1177C15.6465 11.2671 15.6393 11.4146 15.6251 11.5599C15.5827 11.9964 15.9021 12.3847 16.3386 12.4272C16.7751 12.4696 17.1634 12.1502 17.2059 11.7137C17.225 11.5174 17.2348 11.3185 17.2348 11.1177V10.4559ZM3.43225 13.9721C3.15382 13.6333 2.65341 13.5843 2.31454 13.8627C1.97567 14.1411 1.92667 14.6415 2.20509 14.9804C2.45805 15.2883 2.74062 15.5708 3.0485 15.8238C3.38737 16.1022 3.88778 16.0532 4.16621 15.7143C4.44463 15.3755 4.39563 14.8751 4.05676 14.5966C3.8288 14.4094 3.61954 14.2001 3.43225 13.9721ZM15.8527 14.9804C16.1311 14.6415 16.0821 14.1411 15.7432 13.8627C15.4043 13.5843 14.9039 13.6333 14.6255 13.9721C14.4382 14.2001 14.229 14.4094 14.001 14.5966C13.6621 14.8751 13.6131 15.3755 13.8916 15.7143C14.17 16.0532 14.6704 16.1022 15.0093 15.8238C15.3171 15.5708 15.5997 15.2883 15.8527 14.9804ZM6.46904 15.5963C6.03252 15.5538 5.64422 15.8732 5.60173 16.3097C5.55925 16.7462 5.87868 17.1345 6.3152 17.177C6.51151 17.1961 6.71035 17.2059 6.91123 17.2059H7.573C8.01158 17.2059 8.36712 16.8504 8.36712 16.4118C8.36712 15.9732 8.01158 15.6177 7.573 15.6177H6.91123C6.7618 15.6177 6.6143 15.6104 6.46904 15.5963ZM11.7426 17.177C12.1791 17.1345 12.4985 16.7462 12.456 16.3097C12.4135 15.8732 12.0252 15.5538 11.5887 15.5963C11.4435 15.6104 11.296 15.6177 11.1465 15.6177H10.4848C10.0462 15.6177 9.69064 15.9732 9.69064 16.4118C9.69064 16.8504 10.0462 17.2059 10.4848 17.2059H11.1465C11.3474 17.2059 11.5462 17.1961 11.7426 17.177Z"
        fill="#AEAEAE"
      />
    ) : category === BoundaryLegendCategory.County ? (
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3 3.125L3 5H1.875L1.875 6H4V3.125L3 3.125ZM1 5L1 6V7.4375H0L0 5H1ZM0 9.0625H1L1 13.9375H0L0 9.0625ZM0 15.5625H1L1 17H3.75V18H0L0 15.5625ZM6.25 18V17H9.7132L12.47 15.277L13 16.125L10 18H6.25ZM15 14.875L14.47 14.027L17 12.4458V10.5625H18V13L15 14.875ZM18 8.9375H17V4.0625H18V8.9375ZM18 2.4375H17V1L15.1875 1V0L18 0V2.4375ZM13.3125 0V1L7.6875 1V0L13.3125 0ZM5.8125 0V1L4 1V1.875H3V0L5.8125 0Z"
        fill="#999999"
      />
    ) : category === BoundaryLegendCategory.State ? (
      <>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 0H18V18H0V0ZM5 5V13H13V5H5Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 4V0H4V3H3V4H0ZM13 0H5V3H13V0ZM14 0V3H15V4H18V0H14ZM18 5H15V13H18V5ZM18 14H15V15H14V18H18V14ZM13 18V15H5V18H13ZM4 18V15H3V14H0V18H4ZM0 13H3V5H0V13Z"
          fill="#333333"
        />
      </>
    ) : category === BoundaryLegendCategory.Tract ? (
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4 1V6H1V17H9.71321L17 12.4458V1H12V2H11V1H6V2H5V1H4ZM18 13L10 18H0V5H3V0H18V13ZM11 5H12V6H11V5ZM5 9H6V10H5V9ZM3 11H2V12H3V11ZM2 15H3V16H2V15ZM8 15H9V16H8V15ZM8 11H9V12H8V11ZM15 11H14V12H15V11ZM5 13H6V14H5V13ZM12 13H11V14H12V13ZM12 9H11V10H12V9ZM5 5H6V6H5V5ZM2 7H3V8H2V7ZM9 7H8V8H9V7ZM8 3H9V4H8V3ZM15 7H14V8H15V7ZM14 3H15V4H14V3Z"
        fill="#696969"
      />
    ) : category === BoundaryLegendCategory.SelectedTract ? (
      <>
        <path
          d="M3.75 5V5.75H3H0.75L0.75 17.25H9.7849L17.25 12.5843V0.75L3.75 0.75L3.75 5Z"
          fill="#02929B"
          fillOpacity="0.2"
          stroke="#02929B"
          strokeWidth="1.5"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10 1H11V2H10V1ZM11 5H10V6H11V5ZM5 9H4V10H5V9ZM1 11H2V12H1V11ZM2 15H1V16H2V15ZM8 15H7V16H8V15ZM8 11H7V12H8V11ZM13 11H14V12H13V11ZM5 13H4V14H5V13ZM10 13H11V14H10V13ZM10 9H11V10H10V9ZM5 5H4V6H5V5ZM4 1H5V2H4V1ZM2 7H1V8H2V7ZM7 7H8V8H7V7ZM8 3H7V4H8V3ZM13 7H14V8H13V7ZM14 3H13V4H14V3Z"
          fill="#02929B"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.5 7.5H2.5V15.5H9.22019L15.5 11.6873V2.5H5.5V7.5ZM16.5 1.5V12.25L9.5 16.5H1.5V6.5H4.5V1.5H16.5Z"
          fill="white"
        />
      </>
    ) : (
      ""
    );

  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
    >
      {icon}
    </svg>
  );
};

export default BoundaryLegendIcon;
